<template>
    <CSidebar id="appSideBar" fixed
              :minimize="minimize"
              :show="show"
              dropdownMode="closeInactive"
              @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
        <CSidebarBrand class="d-md-down-none" to="/">
            <img class="navbar-brand-full" src="img/logo.png" height="35" alt="Logo" style="padding-right: 5px" v-show="minimize">
            <img class="navbar-brand-full" src="img/logo2.png" height="45" alt="Logo" style="padding-right: 5px" v-show="!minimize">
        </CSidebarBrand>

        <CRenderFunction flat :content-to-render="nav" />
        <CSidebarMinimizer class="d-md-down-none"
                           @click.native="minimize = !minimize" />
    </CSidebar>
</template>

<script>
    import nav from './_nav'

    export default {
        name: 'TheSidebar',
        data() {
            return {
                minimize: false
            }
        },
        computed: {
            nav() {
                var result = JSON.parse(JSON.stringify(nav));
                var navItems = result[0]._children;
                var privileges = this.$store.state.identity.privileges;
                var isAdmin = this.$store.state.identity.isAdmin;
                var isTopLevel = this.$store.state.identity.isTopLevelUnit;

                RemoveUnauthorizedItems(navItems);

                function RemoveUnauthorizedItems(items) {
                    if (items && items.length > 0) {
                        for (var i = items.length - 1; i >= 0; i--) {
                            var item = items[i];

                            if (item.adminOnly && !isAdmin) {
                                items.remove(item);

                                continue;
                            }

                            if (item.topLevelOnly && !isTopLevel) {
                                items.remove(item);

                                continue;
                            }

                            var requiresPrivileges = item.requiresPrivileges || [];
                            if ((item.items || item._children) && (item.items || item._children).length > 0) {
                                requiresPrivileges = requiresPrivileges.concat((item.items || item._children).map(x => x.requiresPrivileges).reduce((x, y) => (x || []).concat(y || [])));
                            }


                            if (requiresPrivileges && requiresPrivileges.length > 0
                                && intersect(privileges, requiresPrivileges).length == 0) {
                                items.remove(item);
                            } else {
                                RemoveUnauthorizedItems(item.items || item._children);
                            }
                        }
                    }
                }

                return result;
            },
            show() {
                return this.$store.state.common.sidebarShow;
            },
            sidebarOpeningItem() {
                return this.$store.state.common.sidebarOpeningItem;
            }
        },
        created() {
            var minimize = window.localStorage.getItem('tsc:sidebarMinimize');

            if (minimize) {
                this.minimize = minimize == 'true';
            }

            this.$root.$sidebar = this;
        },
        watch: {
            minimize(newVal) {
                window.localStorage.setItem('tsc:sidebarMinimize', newVal);
            },
            sidebarOpeningItem(newVal) {
                if (newVal) {
                    $('#appSideBar ul')[0].scrollTo(0, 0);
                }
            }
        }
    }
</script>
